import axios from "@/utils/axios";
import { caiji_submit , caiji_last_history , caiji_history , caiji_all_user , caiji_today_user , not_token_osspolicy } from "@/api";
import { base64ToBlob } from "../utils";
import { Notify } from 'vant';
let code = {
  namespaced: true,
  state: {
    
  },
  mutations: {
    //今日患者
    todayUser(state,params){
        axios(`/kfApi${caiji_today_user}`,params.data,'POST').then((data)=>{
            if(data.code === 1){
                params.fun(data.data);
            }
        })
    },
    //提交
    caijiSubmit(state,params){
        axios(`/kfApi${caiji_submit}`,params.data,'POST').then((data)=>{
            if(data.code === 1){
                params.fun();
            }else if(params.errorfun){
                params.errorfun();
            }
        })
    },
    //根据用户ID获取最后提交的信息及用户信息
    lastHistory(state,params){
        axios(`/kfApi${caiji_last_history}`,params.data).then((data)=>{
            if(data.code === 1){
                params.fun(data.data);
            }
        })
    },
    //历史记录
    history(state,params){
        axios(`/kfApi${caiji_history}`,params.data,'POST').then((data)=>{
            if(data.code === 1){
                params.fun(data.data);
            }
        })
    },
    //全部患者
    allUser(state,params){
        axios(`/kfApi${caiji_all_user}`,params.data,'POST').then((data)=>{
            if(data.code === 1){
                params.fun(data.data);
            }
        })
    },
    //改变数值
    change(state,data){
        state[data.key] = data.value;
    },
    //上传oss
    oss(state,params){
        const blob = base64ToBlob(params.base64);
        axios(`/api${not_token_osspolicy}`,{}).then((data)=>{
            if(data.code === 1){
                let res = data.data
                const formData = new FormData();
                let dir = res.Key + new Date().getTime();
                formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
                formData.append("Policy", res.Policy);
                formData.append("Signature", res.Signature);
                formData.append("Key", dir);
                formData.append("Callback", res.Callback);
                formData.append("File", blob);
                axios(`https://${res.Host}`,formData,'POST',{},true).then(ress => {
                    if(ress.Code===0){
                        const src = `https://${res.Host}/${ress.Data.FileName}`;
                        params.fun(src);
                    }
                })
            }
        })
        // axios(`/api${not_token_osspolicy}`,{photo:params.base64},'POST').then((data)=>{
        //     if(data.code === 1){
        //         params.fun(data.data.url);
        //     }
        // })
    }
  },
  actions: {
    //异步方法
    todayUserData ({ commit }, params) {
      commit ("todayUser", params);
    },
    caijiSubmitData ({ commit }, params) {
        commit ("caijiSubmit", params);
    },
    lastHistoryData ({ commit }, params) {
        commit ("lastHistory", params);
    },
    historyData ({ commit }, params) {
        commit ("history", params);
    },
    allUserData ({ commit }, params) {
        commit ("allUser", params);
    },
    ossData ({ commit }, params) {
        commit ("oss", params);
    }
  },
  getters: {},
};

export default code;
